import constant from '../../store/constant'
import safetyConfirmation from '../../store/modules/safety-confirmation'
import AppHeader from '../AppHeader'

export default {
  name: 'user-detail',
  created () {
    this.search()
    this.isStepUpExist()
  },
  data () {
    return {
      // PDF表示ウィンドウ
      pdfWnd: null,
      callbackflg: false,
      stepUpEnd: false,
      stepUpExist: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.userDetail
    },
    userServiceQuestionId () {
      return this.$store.getters.userServiceQuestionId
    },
    userServiceQuestionAnswerStartDate () {
      return this.$store.getters.userServiceQuestionAnswerStartDate
    },
    content () {
      return this.user.attributes['business-type-content'] ? this.user.attributes['business-type-content'].replace(/\r?\n/g, '<br>') : ''
    },
    overRemark () {
      return this.user.attributes['user-turnover-type-remarks'] ? this.user.attributes['user-turnover-type-remarks'].replace(/\r?\n/g, '<br>') : ''
    },
    userMemo () {
      return this.user.attributes['user-memo'] ? this.user.attributes['user-memo'].replace(/\r?\n/g, '<br>') : ''
    },
    remark () {
      return this.user.attributes['user-business-type-remarks'] ? this.user.attributes['user-business-type-remarks'].replace(/\r?\n/g, '<br>') : ''
    },
    csvData () {
      return this.$store.getters.csvDownload
    },
    csvShopsData () {
      return this.$store.getters.csvShops
    },
    csvUsertypesData () {
      return this.$store.getters.csvUsertypes
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    userDetailLoading () {
      return this.$store.getters.userDetailLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    isHumanStaffLocal () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    postFirst () {
      return this.user.attributes['user-post-no'] ? this.user.attributes['user-post-no'].substring(0, 3) : ''
    },
    postLast () {
      return this.user.attributes['user-post-no'] ? this.user.attributes['user-post-no'].substring(3, 7) : ''
    },
    isShopMaster () {
      if (this.user.attributes['is-shop-master']) {
        return true
      } else {
        return false
      }
    },
    isShiftCreator () {
      if (this.user.attributes['is-shift-creator']) {
        return true
      } else {
        return false
      }
    },
    isHumanStaff () {
      if (this.user.attributes['is-human-staff']) {
        return true
      } else {
        return false
      }
    },
    afterOver () {
      var today = new Date()
      var todaydate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()
      var overdate = this.user.attributes['user-overday'] ? this.user.attributes['user-overday'].replace(/-/g,"") : 99999999
      if (overdate <= todaydate){
        return true
      } else {
        return false
      }
    },
    beforeOver () {
      var today = new Date()
      var todaydate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()
      var overdate = this.user.attributes['user-overday'] ? this.user.attributes['user-overday'].replace(/-/g,"") : todaydate
      if (overdate > todaydate){
        return true
      } else {
        return false
      }
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    safetyConfirmationId() {
      return this.$route.query.safetyConfirmationId
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goUsers: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goBackList: function () {
      if (window.sessionStorage.getItem("retiree") == 'on') {
        this.$router.push({ path: '/retiree/'})
      } else {
        this.$router.push({ path: '/users/'})
      }
    },
    search: function() {
      var self = this
      var data = {}
      var callback
      callback = function() {
        self.callbackflg = true
      }
      this.$store.dispatch('USER_DETAIL',  {id: this.$route.params.id, data: data, callback: callback})
    },
    async isStepUpExist () {
      let data = {
        user_id: this.$route.params.id
      }
      let res = await this.$store.dispatch('IS_STEPUP_ENTRY_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpExist = res.step_up_exist
      this.stepUpEnd = true
    },
    goUserEdit: function(userId) {
      this.$router.push({ path: '/users/' + userId + '/edit'})
    },
    goUserOver: function(userId) {
      if (this.isShopMaster && !this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (!this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんはシフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者兼シフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isHumanStaff) {
        window.alert(this.user.attributes['user-name'] + 'さんは人事担当者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        window.sessionStorage.setItem('BackPage', '/users/'+ userId)
        this.$router.push({ path: '/users/' + userId + '/over'})
      }
    },
    goUserHistory: function(userId) {
      window.sessionStorage.setItem('BackPage', '/users/'+ userId)
      this.$router.push({ path: '/userhistory/' + userId })
    },
    goServiceAnswer: function(userId) {
      this.$router.push({ path: `/service_question/results/${this.userServiceQuestionId}/${userId}/${this.userServiceQuestionAnswerStartDate}?from=user` })
    },
    goUserPdf: function(userId) {
      window.sessionStorage.setItem('BackPage', '/users/'+ userId)
      this.$router.push({ path: '/users/' + userId + '/pdf'})
    },
    userDelete: function() {
      if (this.isShopMaster && !this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (!this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんはシフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isShopMaster && this.isShiftCreator) {
        window.alert(this.user.attributes['user-name'] + 'さんは店舗管理者兼シフト作成者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.isHumanStaff) {
        window.alert(this.user.attributes['user-name'] + 'さんは人事担当者です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else if (this.stepUpExist) {
        window.alert(this.user.attributes['user-name'] + 'さんはステップアップ期間中です。\n変更を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        var self = this
        var data = {}
        var callback = function() {
          self.$router.push({ path: '/users', query: { type: self.$router.currentRoute.query.type}})
        }
        if (window.confirm(this.$t('Delete Confirm'))) {
          data = self.$route.params.id
          this.$store.dispatch('USER_DELETE',  {data: data, callback: callback})
        }
      }
    },
    onGetPdf: function(data) {
      this.pdfWnd.location.href = data.url
      // ファイル削除
      this.$store.dispatch(
        'USER_REMOVE_PDF',
        { data: {download_id: data.download_id}, callback: (data) => {} ,loadparams: 'block'}
      )
    },
    /* 名簿作成ボタン */
    onClickPdf: function(userId) {
      let self = this
      var callback = function(ret) {
          let retStr = JSON.stringify(ret)
          let protocol = location.protocol;
          let url = protocol + "//" + ret.url;
          let form = document.getElementById("pdf_detail_download")
          form.action = url
          document.getElementById("token").value = window.localStorage.getItem('access_token')
          document.getElementById("download_id").value = ret.download_id;
          form.submit();

      }
      this.$store.dispatch('USER_DETAIL_PDF', { data: { "user_id": userId }, callback: callback })
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    retireCancel: function () {
      if (window.confirm(this.$t('Retire Cancel Confirm'))) {
        var data = {}
        var self = this
        var callback = function() {
          self.$router.push({ path: '/users'})
        }
        this.$store.dispatch('USEROVER_CANCEL', { data: data, callback: callback, id: self.$route.params.id })
      }
    },
    telChange: function (tel) {
      return 'tel:' + tel
    },
    csvDownload: function() {
      var self = this
      var data = {
        'user_id': this.$route.params.id,
        'retiree': '',
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds
      }
      var callback = function() {
        self.csvFileName = 'userList.csv'

        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var mimeType = 'text/csv'
        var csv = '社員番号,社員ID,氏名,ふりがな,性別,生年月日,年齢,所属店舗,役職,入社日,入社経緯,郵便番号,住所,携帯番号,電話番号,メールアドレス,備考,個人メモ,役職異動後１,役職異動後日付１,役職異動後２,役職異動後日付２,役職異動後３,役職異動後日付３,店舗異動後１,店舗異動後日付１,店舗異動後２,店舗異動後日付２,店舗異動後３,店舗異動後日付３,運転免許証の登録の有無,任意保険証の登録の有無,車検証の登録の有無,身元保証書・保証人住民票・印鑑登録証明書・保証人確認票の登録の有無,誓約書の登録の有無,住民票の登録の有無,緊急連絡先・履歴書の登録の有無,制服貸与同意書の登録の有無,指導履歴の有無,面談履歴の有無,運転免許証期限日,任意保険証期限日,車検証期限日,身元保証書・保証人住民票・印鑑登録証明書・保証人確認票期限日,離職日,離職区分,離職事由,離職事由補記\n'
        self.csvData.forEach(function (obj) {
          if (obj.attributes['code']) {
            csv += obj.attributes['code'] + ","
          } else {
            csv += obj.id + ","
          }
          csv += obj.id + ","
          if (obj.attributes['user-name']) {
            csv += obj.attributes['user-name'].replace( /,/g, '') + '　' + obj.attributes['user-firstname'] + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-name-furigana'] && obj.attributes['user-firstname-furigana']) {
            csv += obj.attributes['user-name-furigana'].replace( /,/g, '') + '　' + obj.attributes['user-firstname-furigana'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['sex']) {
            csv += obj.attributes['sex'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-birthday']) {
            csv += obj.attributes['user-birthday'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['age']) {
            csv += obj.attributes['age'] + ","
          } else {
            csv += ","
          }
          if (obj.attributes['shop-name']) {
            csv += obj.attributes['shop-name'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-type-name']) {
            csv += obj.attributes['user-type-name'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-joinday']) {
            csv += obj.attributes['user-joinday'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['join-class']) {
            csv += obj.attributes['join-class'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-post-no']) {
            csv += obj.attributes['user-post-no'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-address']) {
            csv += obj.attributes['user-address'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-mobile']) {
            csv += obj.attributes['user-mobile'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-tel']) {
            csv += obj.attributes['user-tel'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['email']) {
            csv += obj.attributes['email'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-memo']) {
            csv += self.enquoteForCSV(obj.attributes['user-memo']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-business-type-remarks']) {
            csv += self.enquoteForCSV(obj.attributes['user-business-type-remarks']) + ","
          } else {
            csv += ","
          }
          //役職履歴の検索直近の３件
          var user_type_change_day_1 = ''
          var user_type_name_after_1 = ''
          var user_type_change_day_2 = ''
          var user_type_name_after_2 = ''
          var user_type_change_day_3 = ''
          var user_type_name_after_3 = ''

          for(var i=0; i < self.csvUsertypesData.length; i++){

            if (obj.id == self.csvUsertypesData[i].attributes['user-id']) {
              if (user_type_change_day_1 == '') {
                user_type_change_day_1 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_1 = self.csvUsertypesData[i].attributes['user-type-name-after']
              } else if (user_type_change_day_2 == '') {
                user_type_change_day_2 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_2 = self.csvUsertypesData[i].attributes['user-type-name-after']
              } else if (user_type_change_day_3 == '') {
                user_type_change_day_3 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_3 = self.csvUsertypesData[i].attributes['user-type-name-after']
              }
            }
          }
          if (user_type_name_after_1) {
            csv += user_type_name_after_1.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_1) {
            csv += user_type_change_day_1.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (user_type_name_after_2) {
            csv += user_type_name_after_2.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_2) {
            csv += user_type_change_day_2.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (user_type_name_after_3) {
            csv += user_type_name_after_3.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_3) {
            csv += user_type_change_day_3.replace( /,/g, '') + ","
          } else {
            csv += ","
          }

          //店舗履歴の検索直近の３件
          var shop_change_day_1 = ''
          var shop_name_after_1 = ''
          var shop_change_day_2 = ''
          var shop_name_after_2 = ''
          var shop_change_day_3 = ''
          var shop_name_after_3 = ''

          for(var i=0; i < self.csvShopsData.length; i++){

            if (obj.id == self.csvShopsData[i].attributes['user-id']) {
              if (shop_change_day_1 == '') {
                shop_change_day_1 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_1 = self.csvShopsData[i].attributes['shop-name-after']
              } else if (shop_change_day_2 == '') {
                shop_change_day_2 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_2 = self.csvShopsData[i].attributes['shop-name-after']
              } else if (shop_change_day_3 == '') {
                shop_change_day_3 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_3 = self.csvShopsData[i].attributes['shop-name-after']
              }
            }
          }
          if (shop_name_after_1) {
            csv += shop_name_after_1.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (shop_change_day_1) {
            csv += shop_change_day_1.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (shop_name_after_2) {
            csv += shop_name_after_2.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (shop_change_day_2) {
            csv += shop_change_day_2.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (shop_name_after_3) {
            csv += shop_name_after_3.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (shop_change_day_3) {
            csv += shop_change_day_3.replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          csv += obj.attributes['license-file-exist'] + ","
          csv += obj.attributes['insurance-file-exist'] + ","
          csv += obj.attributes['car-file-exist'] + ","
          csv += obj.attributes['background-file-exist'] + ","
          csv += obj.attributes['signature-file-exist'] + ","
          csv += obj.attributes['residence-file-exist'] + ","
          csv += obj.attributes['emergency-file-exist'] + ","
          csv += obj.attributes['uniform-file-exist'] + ","
          csv += obj.attributes['guidance-file-exist'] + ","
          csv += obj.attributes['interview-file-exist'] + ","
          if (obj.attributes['user-license-file-date']) {
            csv += obj.attributes['user-license-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-insurance-file-date']) {
            csv += obj.attributes['user-insurance-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-car-file-date']) {
            csv += obj.attributes['user-car-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-background-file-date']) {
            csv += obj.attributes['user-background-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-overday']) {
            csv += obj.attributes['user-overday'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['turnover-class']) {
            csv += obj.attributes['turnover-class'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['turnover-content']) {
            csv += self.enquoteForCSV(obj.attributes['turnover-content']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-turnover-type-remarks']) {
            csv += self.enquoteForCSV(obj.attributes['user-turnover-type-remarks'])
          }
          csv += "\n"

        })
        var blob = new Blob([bom, csv], { type: mimeType })
        var hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if(window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL){
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        } else {
          window.open('data:' + mimeType + ';base64,' + window.Base64.encode(content), '_blank')
        }
      }
      this.$store.dispatch('USER_CSV_DOWNLOAD', { data: data, callback: callback })
    },
    enquoteForCSV: function(val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val
    },
    goSafetyConfirmationAnswerList: function() {
      this.$router.push(`/safety_confirmations/${this.safetyConfirmationId}/answers`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-detail.js